import { Button } from "@common/components/Atoms/Button";
import {
    SearchEntry,
    SearchLocations,
} from "@common/components/Atoms/SearchFilters";
import Dropdown, {
    DropdownItem,
    DropdownMenu,
} from "@common/components/Molecules/Dropdown";
import memoize from "memoize-one";
import * as React from "react";

/*===========================================================================
  Page-level search controls for page > header > center
/*======================================================================== */

interface JobsPageHeaderCenterProps {
    keyword?: string;
    onChange: (value: { keyword: any; location: any }) => void;
    locationKeyword?: string;
}

interface JobsPageHeaderCenterState {
    keyword?: string;
    location?: any;
}

export class JobsPageHeaderCenter extends React.Component<
    JobsPageHeaderCenterProps,
    JobsPageHeaderCenterState
> {
    private memo: (keyword?: string) => void;

    constructor(props) {
        super(props);

        this.state = {
            keyword: this.props.keyword,
            location: undefined,
        };
        this.memo = memoize(keyword => this.setState({ keyword }));
    }

    onKeywordChange = keyword => {
        this.setState({ keyword });
    };

    onLocationChange = location => {
        this.setState({ location }, () => {
            this.onChange();
        });
    };

    onChange = () => {
        const { keyword, location } = this.state;
        this.props.onChange({
            keyword,
            location,
        });
    };

    onEnter = () => {
        this.onChange();
    };

    onSearch = () => {
        this.onChange();
    };

    render() {
        this.memo(this.props.keyword); // update only when prop changes
        const { keyword } = this.state;
        const { locationKeyword } = this.props;
        return (
            <div className="c-page__searches">
                <SearchEntry
                    label="keywords"
                    dataCy="public-job-search-input"
                    onTypedValueChanged={this.onKeywordChange}
                    onEnterKey={this.onEnter}
                    keyword={keyword}
                    onSubmit={this.onSearch}
                    tabIndex={1}
                />

                <SearchLocations
                    dataCy="public-job-location-search-input"
                    keyword={locationKeyword}
                    onSubmit={this.onLocationChange}
                    tabIndex={2}
                />
            </div>
        );
    }
}

/*===========================================================================
  Page-level actions for <= small screens
/*======================================================================== */

export const JobsSortDropdown = props => (
    <Dropdown right={true}>
        <Button
            id="jobSortDropdownButton"
            dropdown={true}
            className="c-dropdown__toggle"
            onClick={() => {
                return;
            }}
        >
            sort
        </Button>
        <DropdownMenu>
            <DropdownItem
                onClick={() => {
                    props.onSortChange(1);
                }}
            >
                job
            </DropdownItem>
            <DropdownItem
                onClick={() => {
                    props.onSortChange(17);
                }}
            >
                category
            </DropdownItem>
            <DropdownItem
                onClick={() => {
                    props.onSortChange(2);
                }}
            >
                location
            </DropdownItem>
            <DropdownItem
                onClick={() => {
                    props.onSortChange(18);
                }}
            >
                type
            </DropdownItem>
            <DropdownItem
                onClick={() => {
                    props.onSortChange(5);
                }}
            >
                openings
            </DropdownItem>
            <DropdownItem
                onClick={() => {
                    props.onSortChange(21);
                }}
            >
                referral reward
            </DropdownItem>
        </DropdownMenu>
    </Dropdown>
);
